import React, {Component} from 'react'
import {Grid, Row, Col} from 'react-flexbox-grid'
import {
  Link
} from 'react-router-dom'
import './page-does-not-exist-styles.css'
import ReactGA from 'react-ga';
ReactGA.initialize('UA-110112779-1');
ReactGA.pageview(window.location.pathname + window.location.search);

export default class PageDoesNotExist extends Component {
  render() {
    return (
      <Grid>
        <Row middle='xs' center='xs' className='container'>
          <Col xs={12}>
            <h1 className='notExistHeader'>404</h1>
            <p>The page you're looking for does not exist.</p>
            <Link to="/">Go Back Home</Link>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/404/PageDoesNotExist.js